import React, { useState, useEffect, useRef } from 'react';

import { reqGET, repo_img_link, content_language, translate } from '../../../../Utils';

import * as Hosts from "../../../../Hosts";

import { language } from '../Language';

import parse from 'html-react-parser';

import AssecImage from "../../ASSEC_Image/Image"

import Loader from '../../../../loader';
// import "../../Pagina.css";
import "./HomeTeam_03.css"

const HomeTeam = (props) => {

	const [, set_dados] = useState(null)
	const team_list = useRef([])
	const dados_config = useRef([])

    const [team_title, set_team_title] = useState('')
    const [team_subtitle, set_team_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'team' && el.info.active) {
                    set_team_title(translate(el.info.title, lang))
                    set_team_subtitle(translate(el.info.subtitle, lang))
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        const getTeam = async () => {
            reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/team`)
                .then(res => {

                    set_dados(team_list.current = res.data)
                    setLoading(false)

                }).catch(erro => console.log('Erro1', erro))
        }
        getTeam()

    }, [props, lang])

    function get_image_content(el, type) {
  
        let result = ''
  
        if(parseInt(lang_id) !== 1 && el.content[0]['language'] !== undefined && el.content[0]['language'][lang_id] !== undefined && el.content[0]['language'][lang_id] !== null && el.content[0]['language'][lang_id]['media'] !== null && el.content[0]['language'][lang_id]['media']['image'] !== undefined && el.content[0].language[lang_id]['media']['image'].length > 0) { 
          if(type === 'name') {
            result = el.content[0].language[lang_id].media.image[0].name
          }
          else if(type === 'url') {
            result = el.content[0].language[lang_id].media.image[0].url
          }
          else if(type === 'link') {
            result = el.content[0].language[lang_id].media.image[0].link
          }
        } else {
          if(el.content[0].media.image !== undefined && el.content[0].media.image !== null && el.content[0].media.image.length > 0) {
  
            if(type === 'name') {
              result = el.content[0].media.image[0].name
            }
            else if(type === 'url') {
              result = el.content[0].media.image[0].url
            }
            else if(type === 'link') {
              result = el.content[0].media.image[0].link
            }
    
          }
  
        }
  
      return result
    }

    return (
        isloading ?
            <Loader />
		:
            <section id="hometeam_03">
              <div className="container">
                <div className="row">
                  <div className="col-12 title-properties">
                    <h3 className="titulo-pp">
                      {team_title}
                    </h3>
                    {
                      team_subtitle !== '' ?
                        <h4 className={"subtitulo-pp"}>
                          {team_subtitle}
                        </h4>
                      :
                      null
                    }
                    <hr></hr>
                  </div>
                  <div className="col-12 text-end mb-3">
                      <a className="btn btn-expand" href={'./team/all'} >
                          <span>{language[lang].see_all}</span>
                          <i className="bi bi-arrow-right"></i>
                      </a>
                  </div>
                    
                  <div className="col-12">
                      {
                        team_list.current !== undefined && team_list.current !== null && team_list.current.length > 0 ?
                            <>
                            <div className="row gy-4 justify-content-center">
                                {
                                    team_list.current.map((v, k) => {
                                        if(k < 4) {
                                            return (
                                                <div className="col-12 col-md-6" key={k}>
                                                    <a href={"team/" + v.id} title={language[lang].learn_more + ' - ' + (lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title))} >
                                                        <div className="card h-100 justify-content-center">
                                                            <div className='row g-0 align-items-center'>
                                                                <div className="col-12 col-md-4">
                                                                    <AssecImage
                                                                        linkImage={get_image_content(v, 'link') !== '' ? get_image_content(v, 'link') : repo_img_link('nophoto.webp')}
                                                                        width="400"
                                                                        height="300"
                                                                        fit='crop'
                                                                        type='img'
                                                                        sClass='img-fluid'
                                                                        loading="lazy"
                                                                        alt={get_image_content(v, 'name').includes('webp') || get_image_content(v, 'name').includes('jpg') || get_image_content(v, 'name').includes('png') || get_image_content(v, 'name') === '' ? 'team-image' : get_image_content(v, 'name') + ' (team-image)'}
                                                                        title={lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                                                    />
                                                                </div>
                                                                <div className="col-12 col-md-8">
                                                                    <div className="card-body">
                                                                        <div className="team-title">
                                                                            {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}  
                                                                        </div>
                                                                        <div className="team-text">
                                                                            {parse((lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text)))}
                                                                        </div>
                                                                        <div className="btn-link team-link mt-3">
                                                                            {language[lang].learn_more}
                                                                            <i className="bi bi-arrow-right"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            )
                                        } else { 
                                            return null
                                        }
                                    })              
                                }
                            </div>
                            </> 
                        :
                            null
                      }
                  </div>
                  
                </div>
              </div>
            </section>
    )
};
export default HomeTeam;